(function () {
    'use strict';

    angular.module('TurneroApp').service('usuarioInfo',['$sessionStorage', function ($sessionStorage) {
        var usuarioInfo = {};

        usuarioInfo.set = function (usuarioInfo) {
            $sessionStorage.usuarioInfo = usuarioInfo;
        };

        usuarioInfo.get = function () {
            return $sessionStorage.usuarioInfo;
        };

        usuarioInfo.getMenu = function () {
            if ($sessionStorage.usuarioInfo !== undefined && $sessionStorage.usuarioInfo !== null)
                return $sessionStorage.usuarioInfo.Usuario_Menu;
            else
                return null;
        };

        usuarioInfo.getToken = function () {
            if ($sessionStorage.usuarioInfo !== undefined && $sessionStorage.usuarioInfo !== null)
                return $sessionStorage.usuarioInfo.Usu_Token;
            else
                return "";
        };

         usuarioInfo.getUsuarioId = function () {
            if ($sessionStorage.usuarioInfo !== undefined && $sessionStorage.usuarioInfo !== null)
                return $sessionStorage.usuarioInfo.Usu_Id;
            else
                return -1;
        };

        return usuarioInfo;
    }]);
})();


// WEBPACK FOOTER //
// ./app/components/general/usuarioInfo-service.js